module.exports = __webpack_public_path__ + "static/media/product.79fc4989.svg";